<script>
export default {
    name: "WeiveredBillsReport",

    data() {

        return {
            bills: [],
        };
    },

    computed: {

        totalWeivered() {

            if(!this.bills.length) return 0;

            return this.bills.map(bill => bill.weiveredAmount ? parseFloat(bill.weiveredAmount) : 0)
                .reduce((sum, amt) => sum + amt)
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchWeiveredBills(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchWeiveredBills() {

            let url = `AccountsReports/GetWeiveredBIlls?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;

            return this.$http.get(url).then(response => {
                this.bills = response.data;
            }).catch(() => { });
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full p-tiny text-center">
            <h5 class="font-medium text-base">Weivered Bills Report</h5>
        </div>
        <table class="table table-hover" id="weiveredBillsReport">
            <thead class="text-xs">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/5">Patient</th>
                      <th class="p-tiny w-1/6">Bill No</th>
                      <th class="p-tiny w-1/6">Date</th>
                      <th class="p-tiny w-1/6">Reason</th>
                      <th class="p-tiny w-1/6">Approved By</th>
                      <th class="p-tiny w-1/6">Bill Amt</th>
                      <th class="p-tiny w-1/6">Weivered Amt</th>
                  </tr>
            </thead>
            <tfoot class="text-sm font-medium">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/2"></th>
                      <th class="p-tiny w-1/2 text-right">Total: {{ totalWeivered | numberFormat }}</th>
                  </tr>
            </tfoot>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(bill,idx) in bills" :key="idx">
                    <td class="p-tiny w-1/5">{{ bill.patient }}</td>
                    <td class="p-tiny w-1/6">{{ bill.billNo }}</td>
                    <td class="p-tiny w-1/6">{{ bill.txnDate | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ bill.reason }}</td>
                    <td class="p-tiny w-1/6">{{ bill.approvedBy }}</td>
                    <td class="p-tiny w-1/6">{{ bill.billAmount | numberFormat }}</td>
                    <td class="p-tiny w-1/6">{{ bill.weiveredAmount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>